import React, { Component, PropTypes } from 'react';
import styled from 'styled-components';
import { Card, CardText, CardActions, CardTitle, CardHeader } from 'material-ui/Card';
import Chip from 'material-ui/Chip';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import Dialog from 'material-ui/Dialog';
import Badge from 'material-ui/Badge';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import toArray from 'lodash/toArray';
import months from '../../utils/months';
import { database } from '../../utils/configureFirebase';

const visible = 'adminMyAnatomy';
const editWord = 'MA#EDIT#DRIVE';

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const JobsContainer = styled.div`
  & > * + * {
    margin-top: 8px;
  }
`;

const CardIcon = styled.div`
  position: absolute;
  top: 16px;
  right: 40px;
`;

class DriveCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openDeleteModal: false,
      visiblePasscode: '',
      visiblePasscodeErrorMessage: undefined,
      editPassword: '',
      editPasswordErrorMessage: undefined,
      editPasswordModal: false,
    };
  }

  deleteModalOpen = () => {
    this.setState(() => ({
      openDeleteModal: true,
    }));
  }

  deleteModalClose = () => {
    this.setState(() => ({
      openDeleteModal: false,
      visiblePasscode: '',
      visiblePasscodeErrorMessage: undefined,
    }));
  }

  deleteDrive = (driveId) => {
    const { visiblePasscode } = this.state;

    if (visible === visiblePasscode) {
      database.ref().child(`drives/${driveId}`).remove();
      this.setState(() => ({
        visiblePasscodeErrorMessage: undefined,
      }));
    } else if (visiblePasscode === '') {
      this.setState(() => ({
        visiblePasscodeErrorMessage: 'Password is required',
      }));
    } else {
      this.setState(() => ({
        visiblePasscodeErrorMessage: 'Password Incorrect',
      }));
    }
  }

  moveToEdit = (driveId) => {
    const { history } = this.props;
    const { editPassword } = this.state;
    if (editPassword === editWord) {
      this.setState(() => ({
        editPasswordModal: false,
      }));
      history.push(`/drive/edit/${driveId}`);
    } else {
      this.setState(() => ({
        editPassword: '',
        editPasswordErrorMessage: 'Incorrect Password',
      }));
    }
  }

  editPasswordModalOpen = () => {
    this.setState(() => ({
      editPasswordModal: true,
    }));
  }

  editPasswordModalClose = () => {
    this.setState(() => ({
      editPasswordModal: false,
    }));
  }

  moveToRegistration = (driveId) => {
    const { history } = this.props;
    history.push(`/drive/${driveId}`);
  }

  render() {
    const {
      openDeleteModal,
      visiblePasscode,
      visiblePasscodeErrorMessage,
      editPassword,
      editPasswordErrorMessage,
      editPasswordModal,
    } = this.state;
    const {
      id,
      companyName,
      companyDescription,
      jobs,
      location,
      date,
      lastRegdDate,
      streams,
      degrees,
      skills,
      count,
    } = this.props;
    return (
      <div>

        <Card style={{ position: 'relative' }}>
          <CardIcon>
            <Badge
              badgeContent={count}
              primary
              badgeStyle={{ top: 0, right: 0 }}
              style={{ paddingTop: '10px' }}
            />
            <IconMenu
              iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
              targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
              <MenuItem
                leftIcon={<EditIcon />}
                primaryText="Edit"
                onTouchTap={() => {
                  this.editPasswordModalOpen();
                }}
              />
              <MenuItem
                leftIcon={<DeleteIcon />}
                primaryText="Delete"
                onTouchTap={this.deleteModalOpen}
              />
            </IconMenu>
          </CardIcon>
          <CardTitle
            title={companyName}
            subtitle={`${location.description} |
              Campus Date - ${date.date} ${months[date.month].name}, ${date.year} | 
              Last Registration Date - ${lastRegdDate.date} ${months[lastRegdDate.month].name}, ${lastRegdDate.year}`}
            titleStyle={{ width: '624px' }}
            actAsExpander
          />
          <CardText expandable>
            <CardHeader title="Description" style={{ paddingLeft: 0 }} />
            {companyDescription
              .split('\n')
              .map((text, i) => <p key={i}>{text}</p>)
            }
            <CardHeader title="Jobs" style={{ paddingLeft: 0 }} />
            <JobsContainer>
              {jobs.map(job => (
                <Card key={job.id}>
                  <CardHeader
                    title={job.jobPosition}
                    subtitle={`${job.jobType} | ${job.jobLocation}`}
                    showExpandableButton
                    actAsExpander
                  />
                  <CardText expandable>
                    <CardHeader
                      title={job.jobType === 'FTE' ? 'Cost To Company' : 'Stipened'}
                      style={{ paddingLeft: 0 }}
                    />
                    {job.jobCtc}
                    <CardHeader
                      title="Job Description"
                      style={{ paddingLeft: 0 }}
                    />
                    {job.jobDescription
                      .split('\n')
                      .map((text, i) => <p key={i}>{text}</p>)
                    }

                  </CardText>
                </Card>
              ))}
            </JobsContainer>
            <CardHeader
              title="Registration Link"
              style={{ paddingLeft: 0 }}
            />
            <a
              href={`https://drive.myanatomy.in/drive/${id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`https://drive.myanatomy.in/drive/${id}`}
            </a>
            <CardActions style={{ paddingLeft: 0, marginTop: '16px' }}>
              <RaisedButton
                primary label="View Registrations"
                onTouchTap={() => {
                  this.moveToRegistration(id);
                }}
              />
            </CardActions>

            <CardHeader
              title="Elibigle Degrees"
              style={{ paddingLeft: 0 }}
            />
            <ChipsContainer>
              {degrees.map(degree => (
                <Chip
                  key={degree}
                  style={{
                    marginBottom: 8,
                    marginRight: 8,
                  }}
                >
                  {degree}
                </Chip>
              ))}
            </ChipsContainer>
            <CardHeader
              title="Elibigle Branches"
              style={{ paddingLeft: 0 }}
            />
            <ChipsContainer>
              {toArray(streams).map(stream => (
                <Chip
                  key={stream.id}
                  style={{
                    marginBottom: 8,
                    marginRight: 8,
                  }}
                >
                  {stream.stream}
                </Chip>
              ))}
            </ChipsContainer>
            {skills ? (
              <div>
                <CardHeader
                  title="Elibigle Skills"
                  style={{ paddingLeft: 0 }}
                />
                <ChipsContainer>
                  {toArray(skills).map(skill => (
                    <Chip
                      key={skill.id}
                      style={{
                        marginBottom: 8,
                        marginRight: 8,
                      }}
                    >
                      {skill.skill}
                    </Chip>
                  ))}
                </ChipsContainer>
              </div>
            ) : null}
          </CardText>
        </Card>
        <Dialog
          title="Delete Drive"
          actions={[
            <FlatButton
              label="Cancel"
              primary
              onTouchTap={this.deleteModalClose}
            />,
            <RaisedButton
              label="Delete"
              secondary
              onTouchTap={() => {
                this.deleteDrive(id);
              }}
            />,
          ]}
          open={openDeleteModal}
          onRequestClose={this.deleteModalClose}
        >
          <CardText>
            <TextField
              floatingLabelText="Please enter Password to deleting the drive."
              fullWidth
              type="password"
              hintText="******"
              errorText={visiblePasscodeErrorMessage}
              value={visiblePasscode}
              onChange={(_, value) => {
                this.setState(() => ({
                  visiblePasscode: value,
                }));
              }}
            />
          </CardText>
        </Dialog>

        <Dialog
          title="Edit Drive Password"
          actions={[
            <FlatButton
              label="Cancel"
              primary
              onTouchTap={this.editPasswordModalClose}
            />,
            <RaisedButton
              label="Submit"
              secondary
              onTouchTap={() => {
                this.moveToEdit(id);
              }}
            />,
          ]}
          open={editPasswordModal}
          onRequestClose={this.editPasswordModalClose}
        >
          <CardText>
            <TextField
              floatingLabelText="Please enter Password to edit the drive."
              fullWidth
              type="password"
              hintText="******"
              errorText={editPasswordErrorMessage}
              value={editPassword}
              onChange={(_, value) => {
                this.setState(() => ({
                  editPassword: value,
                }));
              }}
            />
          </CardText>
        </Dialog>
      </div >
    );
  }
}

DriveCard.propTypes = {
  id: PropTypes.string.isRequired,
  companyDescription: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  jobs: PropTypes.array.isRequired, //eslint-disable-line
  degrees: PropTypes.array.isRequired, //eslint-disable-line
  skills: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]), //eslint-disable-line
  location: PropTypes.shape({
    description: PropTypes.string,
  }).isRequired, // eslint-disable-line
  date: PropTypes.object.isRequired, // eslint-disable-line
  lastRegdDate: PropTypes.object.isRequired, // eslint-disable-line
  streams: PropTypes.array.isRequired, // eslint-disable-line
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  count: PropTypes.number.isRequired,
};

DriveCard.defaultProps = {
  skills: undefined,
};

export default DriveCard;



// WEBPACK FOOTER //
// ./src/components/DriveCard/DriveCard.js